import { PICKER_LANGUAGES, normalizeToPickerLanguage } from "./config";

export const getPickerLanguages = (): string[] => [...PICKER_LANGUAGES];

/**
 * Validates against the picker list only, so a locale still under test never
 * gets picked up implicitly (e.g. from navigator.language).
 */
export const normalizePickerLanguage = (value?: string | null): string | null => normalizeToPickerLanguage(value);
